export const environment = {
    production: false,
    baseUrl: 'https://api.crm.honesty-stg.ai/api',
    clientID: 'a09fa542-ab88-4e0f-bdc0-5d28674c95a0',
    authority: 'https://login.microsoftonline.com/3942144b-d439-4c0b-9ed9-8a9c2ba44b85',
    sentryDsn: 'https://b6cd40eaf09fac5ccf972857ab07d08c@o4506020951031808.ingest.us.sentry.io/4507934973886464',
    sentryEnvironment: 'staging',
    tracesSampleRate: 0.5,
    lifeTimeAssociationFee: 0.0,
    jetUrl: 'https://jet-aca.com',
};
